export const products = [
    {
        id: "glass-block-supplier",
        navLabel: "Glass Block Supplier",
        slug: "glass-block-supplier",
        heroTitle: "Best Glass Block Supplier",
        heroSubtitle: "Chhatarpur, Vasant Kunj & South Delhi",
        metaTitle: "Best Glass Block Supplier in Chhatarpur, Vasant Kunj & South Delhi | SNS Glass House",
        metaDescription: "Premium glass block (190x190x80mm) supply & installation in South Delhi. Trusted glass block dealer in Chhatarpur, Vasant Kunj & Delhi NCR. Call 9716043891.",
        tagline: "Glass Block Dealer & Supplier in Delhi – S.N.S. Glass House",
        intro: {
            heading: "Best Glass Block Supplier in Chhatarpur, Vasant Kunj & South Delhi and in Delhi NCR",
            searchingFor: [
                "Glass block dealer near me",
                "190x190 glass block supplier in Delhi",
                "Solid glass bricks in South Delhi",
                "Glass block wall contractor in Chhatarpur",
                "Glass block installation in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House is your trusted solution. We provide premium quality glass blocks (190x190x80 mm) for residential, commercial and architectural projects across Chhatarpur, Vasant Kunj, Saket, Malviya Nagar, Mehrauli, South Delhi & Delhi NCR.",
        },
        whatIs: {
            heading: "What Are Solid Glass Blocks?",
            description:
                "Solid glass blocks, also known as glass bricks, are high-strength architectural glass units used to create light-transmitting walls and decorative partitions. Unlike traditional bricks, glass blocks allow natural sunlight, maintain privacy, enhance modern interiors, and improve aesthetic value.",
            points: [
                "190mm × 190mm × 80mm Glass Block",
                "Clear Glass Block",
                "Frosted Glass Block",
                "Pattern Designer Glass Brick",
            ],
        },
        applications: [
            {
                title: "Bathroom Glass Block Partition",
                points: ["Bathroom shower partition", "Wet and dry area separation", "Small bathroom light walls"],
                note: "They are waterproof and ideal for Delhi apartments and builder floors.",
            },
            {
                title: "Office & Commercial Glass Block Walls",
                points: ["Reception backdrop walls", "Office cabin partitions", "Showroom display walls", "Staircase lighting walls"],
                note: "Many clients searching for 'office glass block partition in Delhi' choose S.N.S. Glass House for premium finishing.",
            },
            {
                title: "Exterior Glass Block Wall for Elevation",
                points: ["Building front elevation design", "Balcony side walls", "Parking light walls", "Staircase exterior walls"],
                note: "They reduce daytime electricity use by allowing natural light.",
            },
            {
                title: "Residential Interior Decoration",
                points: ["Living room divider", "Kitchen partition wall", "Pooja room glass partition", "Corridor light enhancement"],
                note: "Searching for 'glass brick wall design in South Delhi'? We provide customized designs.",
            },
        ],
        faqs: [
            { q: "Are glass blocks strong?", a: "Yes, solid glass blocks are durable and suitable for non-load bearing walls." },
            { q: "Can glass block walls break easily?", a: "No. They are impact-resistant when installed properly." },
            { q: "Are they safe for bathroom use?", a: "Yes, they are 100% waterproof and moisture resistant." },
            { q: "Do glass blocks require maintenance?", a: "Very low maintenance. Simple cleaning keeps them clear." },
            { q: "How many glass blocks are required per square foot?", a: "Approximately 2.7 to 3 blocks per sq ft depending on spacing." },
            { q: "What is the most popular glass block size?", a: "190x190x80 mm is the most common size used in India." },
            { q: "Can I customize the design?", a: "Yes, custom layouts and patterns are available." },
        ],
        whyChoose: [
            "20+ Years Experience in Glass Industry",
            "Trusted Glass Contractor in South Delhi",
            "Professional Installation Team",
            "Affordable Pricing",
            "On-time Completion",
        ],
        pricingNote:
            "Pricing depends on quantity required, design type, installation height and site condition. For accurate quotation and site visit, contact 9716043891.",
    },

    {
        id: "frameless-glass-partition",
        navLabel: "Frameless Glass Partition",
        slug: "frameless-glass-partition",
        heroTitle: "Best Frameless Glass Partition",
        heroSubtitle: "Chhatarpur, Vasant Kunj & South Delhi",
        metaTitle: "Best Frameless Glass Partition Work in Chhatarpur, Vasant Kunj & South Delhi | SNS Glass House",
        metaDescription: "Premium frameless toughened glass partitions for offices & showrooms in South Delhi. Expert contractor in Chhatarpur & Vasant Kunj. Call 9716043891.",
        tagline: "Frameless Glass Partition Dealer & Contractor in South Delhi | S.N.S. Glass House",
        intro: {
            heading: "Best Frameless Glass Partition Work in Chhatarpur, Vasant Kunj & South Delhi",
            searchingFor: [
                "Frameless glass partition near me",
                "Office glass cabin partition in Delhi",
                "Toughened glass partition contractor in South Delhi",
                "Glass office partition in Chhatarpur",
                "Glass partition work in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House provides premium frameless toughened glass partitions for offices, showrooms, clinics, studios, and commercial spaces across South Delhi & NCR.",
        },
        whatIs: {
            heading: "What Is Frameless Glass Partition?",
            description:
                "Frameless glass partition is a modern interior solution made using 8mm, 10mm or 12mm toughened glass without heavy aluminum framing. It creates a clean & premium corporate look, maximum light flow, spacious appearance, and professional office environment.",
            points: [
                "8mm, 10mm or 12mm toughened glass",
                "No heavy aluminium framing",
                "Frosted film & branding options",
                "Sliding and hinged door options",
            ],
        },
        applications: [
            {
                title: "Office Cabin Partition",
                points: ["Manager cabins", "Conference rooms", "Director cabins", "Startup offices"],
                note: "We handle complete supply & installation for office glass cabin partitions in South Delhi.",
            },
            {
                title: "Showroom & Retail Store Partition",
                points: ["Boutique stores", "Jewelry shops", "Mobile showrooms", "Display areas"],
                note: "Enhances visibility and modern appeal.",
            },
            {
                title: "Clinic & Commercial Spaces",
                points: ["Dental clinics", "Pathology labs", "Hospitals", "CA offices"],
                note: "Glass partitions maintain hygiene and transparency.",
            },
            {
                title: "Residential Use",
                points: ["Study room divider", "Living room partition", "Balcony enclosure", "Home office cabin"],
                note: "Yes, frameless glass partitions can be used at home for a sleek, modern look.",
            },
        ],
        faqs: [
            { q: "Is frameless glass partition strong?", a: "Yes. We use toughened safety glass (8mm–12mm), which is 4–5 times stronger than normal glass." },
            { q: "What happens if glass breaks?", a: "Toughened glass breaks into small blunt pieces, reducing injury risk." },
            { q: "Is it safe for offices?", a: "Yes, completely safe when installed professionally." },
            { q: "Does it reduce noise?", a: "It reduces some sound, but not 100% soundproof. For higher sound control, thicker glass is recommended." },
            { q: "Which glass thickness is best for office partition?", a: "10mm or 12mm toughened glass is most recommended." },
            { q: "How much time does installation take?", a: "Usually 1–3 days depending on size." },
            { q: "Can you install in occupied office?", a: "Yes, we work with minimal disturbance." },
        ],
        whyChoose: [
            "20+ Years Glass Industry Experience",
            "Specialist in Toughened Glass Work",
            "Fast Installation",
            "Affordable Pricing",
            "Serving Chhatarpur, Vasant Kunj & South Delhi",
        ],
        pricingNote:
            "Price depends on glass thickness (8mm / 10mm / 12mm), area size, hardware quality and door fittings. For exact site quotation, contact 9716043891.",
    },

    {
        id: "shower-glass-partition",
        navLabel: "Shower Glass Partition",
        slug: "shower-glass-partition",
        heroTitle: "Best Shower Glass Partition",
        heroSubtitle: "Chhatarpur, Vasant Kunj & South Delhi",
        metaTitle: "Best Shower Glass Partition in Chhatarpur, Vasant Kunj & South Delhi | SNS Glass House",
        metaDescription: "Premium 8mm/10mm toughened glass shower enclosures in South Delhi. Frameless shower cubicles, sliding doors, hinged doors. Call 9716043891.",
        tagline: "Shower Glass Enclosure Dealer & Installation in South Delhi | S.N.S. Glass House",
        intro: {
            heading: "Best Shower Glass Partition in Chhatarpur, Vasant Kunj & South Delhi",
            searchingFor: [
                "Shower glass partition near me",
                "Bathroom glass enclosure in Delhi",
                "Frameless shower cubicle in South Delhi",
                "Toughened glass shower partition in Chhatarpur",
                "Sliding shower glass door in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House provides premium 8mm / 10mm toughened glass shower enclosures for homes, builder floors, luxury apartments and hotels across South Delhi & NCR.",
        },
        whatIs: {
            heading: "What Is a Shower Glass Enclosure?",
            description:
                "A shower enclosure is a bathroom partition made of toughened safety glass that separates the wet and dry areas. It keeps the bathroom dry, prevents water leakage, improves hygiene, enhances modern bathroom design and increases property value. Unlike shower curtains, glass enclosures look premium and last longer.",
            points: [
                "Frameless Shower Partition",
                "Sliding Shower Glass Door",
                "Hinged Shower Door",
                "Corner Shower Cubicle",
            ],
        },
        applications: [
            {
                title: "Frameless Shower Partition",
                points: ["Clean & minimal design", "No heavy aluminum frame", "Premium luxury finish"],
                note: "Most popular in modern South Delhi apartments.",
            },
            {
                title: "Sliding Shower Glass Door",
                points: ["Perfect for small bathrooms", "Compact spaces", "Builder flats"],
                note: "Sliding system saves space and looks elegant.",
            },
            {
                title: "Hinged Shower Door",
                points: ["Opens inside or outside", "Suitable for medium & large bathrooms", "Strong stainless steel hardware"],
                note: "Durable and long lasting with premium hardware.",
            },
            {
                title: "Corner Shower Cubicle",
                points: ["Square or corner bathroom layouts", "Space-saving designs", "Studio apartments"],
                note: "Ideal for compact bathroom spaces.",
            },
        ],
        faqs: [
            { q: "Is shower glass safe?", a: "Yes. We use toughened safety glass (8mm–10mm), which is 4–5 times stronger than normal glass." },
            { q: "What if the glass breaks?", a: "Toughened glass shatters into small blunt pieces, reducing injury risk." },
            { q: "Will water leak outside?", a: "No. Proper sealing and alignment ensure no leakage." },
            { q: "Does glass get stained?", a: "With regular cleaning, it stays clear. We also suggest water-repellent coating." },
            { q: "Which glass thickness is best for shower enclosure?", a: "8mm or 10mm toughened glass is recommended." },
            { q: "How many days does installation take?", a: "Usually 1–2 days." },
            { q: "Can you install in an already finished bathroom?", a: "Yes, we install without damaging tiles." },
        ],
        whyChoose: [
            "20+ Years Experience in Glass Work",
            "Specialist in Toughened Glass Solutions",
            "Fast & Clean Installation",
            "Serving Chhatarpur, Vasant Kunj & Entire South Delhi",
            "Affordable Pricing",
        ],
        pricingNote:
            "Pricing depends on glass thickness (8mm / 10mm), size of enclosure, hardware quality, and sliding or hinged system. For accurate quotation and site visit, contact 9716043891.",
    },

    {
        id: "toughened-glass-supplier",
        navLabel: "Toughened Glass Supplier",
        slug: "toughened-glass-supplier",
        heroTitle: "Best Toughened Glass Supplier",
        heroSubtitle: "Chhatarpur, Vasant Kunj & South Delhi",
        metaTitle: "Best Toughened Glass Supplier in Chhatarpur, Vasant Kunj & South Delhi | SNS Glass House",
        metaDescription: "8mm, 10mm, 12mm & 15mm toughened safety glass supply & installation in South Delhi. Trusted tempered glass dealer. Call 9716043891.",
        tagline: "Toughened Glass Dealer & Installation in South Delhi | S.N.S. Glass House",
        intro: {
            heading: "Best Toughened Glass Supplier in Chhatarpur, Vasant Kunj & South Delhi",
            searchingFor: [
                "Toughened glass near me",
                "10mm / 12mm toughened glass in Delhi",
                "Toughened glass dealer in South Delhi",
                "Toughened glass door in Chhatarpur",
                "Toughened glass shop front in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House supplies and installs premium quality 8mm, 10mm, 12mm & 15mm toughened glass for residential, commercial and industrial projects across South Delhi & NCR.",
        },
        whatIs: {
            heading: "What Is Toughened Glass?",
            description:
                "Toughened glass (also known as tempered glass) is a safety glass that is heat-treated to increase its strength. It is 4–5 times stronger than normal glass. When broken, it shatters into small blunt pieces, reducing injury risk.",
            points: [
                "4–5× stronger than normal glass",
                "Heat resistant & impact resistant",
                "Safer in case of breakage",
                "8mm, 10mm, 12mm & 15mm thickness options",
            ],
        },
        applications: [
            {
                title: "Toughened Glass Doors",
                points: ["Office main entrance", "Showroom front", "Commercial shops", "Mall stores"],
                note: "We provide complete supply & fitting for toughened glass doors in South Delhi.",
            },
            {
                title: "Office Glass Partitions",
                points: ["Frameless cabin partitions", "Conference room walls", "Director cabins", "Corporate offices"],
                note: "10mm or 12mm toughened glass is most preferred.",
            },
            {
                title: "Balcony & Staircase Railing",
                points: ["Glass railing for balcony", "Staircase side glass", "Terrace railing"],
                note: "Modern homes in Vasant Kunj and South Delhi prefer toughened glass railings for premium look.",
            },
            {
                title: "Kitchen & Interior Use",
                points: ["Kitchen backsplash", "Wardrobe shutters", "Glass shelves", "Table tops"],
                note: "Adds elegance and durability to any interior space.",
            },
        ],
        faqs: [
            { q: "Is toughened glass unbreakable?", a: "No glass is 100% unbreakable, but toughened glass is highly impact-resistant." },
            { q: "Which thickness is best?", a: "8mm for shower partitions, 10mm for office partitions, 12mm for doors, 15mm for heavy structural use." },
            { q: "Is it safe for kids?", a: "Yes, because it breaks into small blunt pieces." },
            { q: "Can it handle Delhi heat?", a: "Yes, it is heat resistant and suitable for Indian weather." },
            { q: "What is the difference between normal and toughened glass?", a: "Toughened glass is stronger and safer." },
            { q: "Do you provide custom cut toughened glass?", a: "Yes, fully customized sizes available." },
            { q: "Do you provide supply only?", a: "Yes, both supply & installation options available." },
        ],
        whyChoose: [
            "20+ Years Experience in Glass Industry",
            "Trusted Toughened Glass Dealer in South Delhi",
            "Expert Installation Team",
            "Competitive Pricing",
            "Serving Chhatarpur, Vasant Kunj & Delhi NCR",
        ],
        pricingNote:
            "Pricing depends on thickness, size, edge polishing, and cut-outs & hardware. For accurate quotation & site visit in South Delhi, contact 9716043891.",
    },

    {
        id: "mirror-work-contractor",
        navLabel: "Mirror Work Contractor",
        slug: "mirror-work-contractor",
        heroTitle: "Best Mirror Work Contractor",
        heroSubtitle: "Chhatarpur, Vasant Kunj & South Delhi",
        metaTitle: "Best Mirror Work Contractor in Chhatarpur, Vasant Kunj & South Delhi | SNS Glass House",
        metaDescription: "Custom mirror cutting, polishing & installation in South Delhi. Gym mirrors, decorative mirrors, salon mirrors. Trusted mirror contractor. Call 9716043891.",
        tagline: "Mirror Work & Decorative Mirror Installation in South Delhi | S.N.S. Glass House",
        intro: {
            heading: "Best Mirror Work Contractor in Chhatarpur, Vasant Kunj & South Delhi",
            searchingFor: [
                "Mirror work near me",
                "Decorative mirror wall in Delhi",
                "Gym mirror installation in South Delhi",
                "Custom size mirror in Chhatarpur",
                "Wall mirror fixing in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House provides premium custom mirror cutting, polishing, and installation services across South Delhi & NCR for homes, gyms, salons, studios, offices and commercial spaces.",
        },
        whatIs: {
            heading: "What Is Mirror Work?",
            description:
                "Mirror work includes cutting, shaping, polishing and installing mirrors for decorative, functional and commercial use. We provide plain wall mirrors, decorative mirror panels, beveled edge mirrors, full wall gym mirrors, bathroom vanity mirrors and LED mirror installation.",
            points: [
                "Plain wall mirrors",
                "Decorative mirror panels",
                "Beveled edge mirrors",
                "Full wall gym mirrors",
                "Bathroom vanity mirrors",
                "LED mirror installation",
            ],
        },
        applications: [
            {
                title: "Decorative Mirror Walls",
                points: ["Living room feature wall", "Dining area backdrop", "Bedroom wardrobe mirror", "Lobby decorative panels"],
                note: "Mirrors make small South Delhi flats look bigger and brighter.",
            },
            {
                title: "Gym & Fitness Studio Mirrors",
                points: ["Full wall mirrors", "Dance studio mirrors", "Yoga studio mirrors", "Commercial gym mirror fitting"],
                note: "Proper alignment ensures distortion-free reflection.",
            },
            {
                title: "Salon & Commercial Use",
                points: ["Hair salons", "Makeup studios", "Spa centers", "Boutique stores"],
                note: "Professional mirror fitting enhances business appearance.",
            },
            {
                title: "Bathroom Vanity Mirrors",
                points: ["Plain vanity mirrors", "LED backlit mirrors", "Anti-fog mirrors", "Custom cut mirrors"],
                note: "Searching for 'bathroom mirror installation near me'? We provide on-site service.",
            },
        ],
        faqs: [
            { q: "Which mirror thickness is best?", a: "4mm for light use, 5mm for residential use, 6mm for commercial/gym use." },
            { q: "Do mirrors break easily?", a: "High-quality mirrors are durable but should be handled professionally during installation." },
            { q: "Do you provide edge polishing?", a: "Yes, machine polished edges, beveled edges and designer finishing available." },
            { q: "Can mirrors be customized?", a: "Yes, custom size and shape available." },
            { q: "Can you install full wall mirror in gym?", a: "Yes, we specialize in gym & studio mirror installation." },
            { q: "How long does installation take?", a: "Usually same day or 1–2 days depending on size." },
            { q: "Do you provide mirror replacement service?", a: "Yes, broken mirror replacement available." },
        ],
        whyChoose: [
            "20+ Years Experience in Glass & Mirror Work",
            "Trusted Mirror Contractor in South Delhi",
            "Custom Size & Designer Mirrors",
            "Affordable Pricing",
            "Serving Chhatarpur, Vasant Kunj & Entire Delhi NCR",
        ],
        pricingNote:
            "Pricing depends on mirror thickness, size, edge finishing and installation complexity. For exact quotation & site visit in South Delhi, call 9716043891.",
    },

    {
        id: "aluminium-work-services",
        navLabel: "Aluminium Work Services",
        slug: "aluminium-work-services",
        heroTitle: "Best Aluminium Work Services",
        heroSubtitle: "Chhatarpur, Vasant Kunj & South Delhi",
        metaTitle: "Best Aluminium Work Services in Chhatarpur, Vasant Kunj & South Delhi | SNS Glass House",
        metaDescription: "Aluminium doors, windows, partitions & shop fronts in South Delhi. Expert aluminium fabrication contractor in Chhatarpur. Call 9716043891.",
        tagline: "Aluminium Work Contractor in South Delhi | Aluminium Doors, Windows & Partitions – S.N.S. Glass House",
        intro: {
            heading: "Best Aluminium Work Services in Chhatarpur, Vasant Kunj & South Delhi",
            searchingFor: [
                "Aluminium work near me",
                "Aluminium door & window contractor in Delhi",
                "Aluminium sliding window in South Delhi",
                "Aluminium partition work in Chhatarpur",
                "Aluminium shop front in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House provides high-quality aluminium doors, windows, partitions, shop fronts, and custom aluminium fabrication across South Delhi & NCR. Aluminium is lightweight, rust-resistant, durable, low maintenance, and modern looking — perfect for Delhi's climate conditions.",
        },
        whatIs: {
            heading: "What Is Aluminium Work?",
            description:
                "Aluminium work includes fabrication and installation of aluminium frames combined with glass or panels for residential and commercial spaces. Available in powder-coated & anodized finish.",
            points: [
                "Aluminium Sliding Windows",
                "Aluminium Doors",
                "Aluminium Partitions",
                "Aluminium Shop Fronts",
                "Custom Aluminium Fabrication",
            ],
        },
        applications: [
            {
                title: "Aluminium Sliding Windows",
                points: ["Space-saving design", "Smooth sliding", "Strong frame", "Weather resistant"],
                note: "Most popular in South Delhi apartments. Available in powder-coated & anodized finish.",
            },
            {
                title: "Aluminium Doors",
                points: ["Aluminium glass doors", "Office entrance doors", "Balcony doors", "Sliding aluminium doors"],
                note: "Ideal for homes, offices and commercial spaces.",
            },
            {
                title: "Aluminium Partitions",
                points: ["Office cabins", "Commercial shops", "Residential room dividers"],
                note: "Strong framing with glass panels for professional look.",
            },
            {
                title: "Aluminium Shop Front",
                points: ["Showroom front elevation", "Commercial shop entrance", "Glass & aluminium combination facade"],
                note: "Gives modern and premium appearance.",
            },
        ],
        faqs: [
            { q: "Does aluminium rust?", a: "No, aluminium is rust-resistant and ideal for Indian weather." },
            { q: "Is aluminium stronger than wood?", a: "Yes, aluminium is more durable and termite-free." },
            { q: "How long does aluminium last?", a: "Properly installed aluminium work lasts 15–20+ years." },
            { q: "Is maintenance required?", a: "Very low maintenance. Just normal cleaning is enough." },
            { q: "Which aluminium profile is best?", a: "Heavy-duty powder-coated profiles are recommended." },
            { q: "Can aluminium doors be combined with toughened glass?", a: "Yes, very common and highly durable combination." },
            { q: "Do you provide repair service?", a: "Yes, repair and replacement services available." },
        ],
        whyChoose: [
            "20+ Years Experience in Glass & Aluminium Work",
            "Trusted Aluminium Contractor in South Delhi",
            "High-Quality Materials",
            "Affordable Pricing",
            "Serving Chhatarpur, Vasant Kunj & Entire Delhi NCR",
        ],
        pricingNote:
            "Pricing depends on profile quality, glass type used, size and sliding or fixed system. For accurate quotation & site visit in Vasant Kunj or South Delhi, call 9716043891.",
    },

    {
        id: "glass-railing-installation",
        navLabel: "Glass Railing Installation",
        slug: "glass-railing-installation",
        heroTitle: "Best Glass Railing Installation",
        heroSubtitle: "Chhatarpur, Vasant Kunj & South Delhi",
        metaTitle: "Best Glass Railing Installation in Chhatarpur, Vasant Kunj & South Delhi | SNS Glass House",
        metaDescription: "10mm, 12mm & 15mm toughened glass railing for balcony & staircase in South Delhi. Expert glass railing contractor. Call 9716043891.",
        tagline: "Glass Railing Contractor in South Delhi | Balcony & Staircase Glass Railing – S.N.S. Glass House",
        intro: {
            heading: "Best Glass Railing Installation in Chhatarpur, Vasant Kunj & South Delhi",
            searchingFor: [
                "Glass railing near me",
                "Balcony glass railing in Delhi",
                "Toughened glass railing contractor in South Delhi",
                "Staircase glass railing in Chhatarpur",
                "Frameless glass railing in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House provides premium 10mm, 12mm & 15mm toughened glass railing systems for homes, builder floors, villas, offices and commercial projects across South Delhi & NCR.",
        },
        whatIs: {
            heading: "What Is Glass Railing?",
            description:
                "Glass railing is a modern safety barrier system made using toughened safety glass combined with stainless steel or aluminium fittings. It provides maximum visibility, modern & luxury look, safety & strength, and low maintenance. Perfect for contemporary homes in South Delhi.",
            points: [
                "Balcony Glass Railing",
                "Staircase Glass Railing",
                "Frameless Glass Railing",
                "Terrace Glass Railing",
            ],
        },
        applications: [
            {
                title: "Balcony Glass Railing",
                points: ["Builder floors", "Apartments", "Villas"],
                note: "Enhances front elevation appearance. Most popular choice in South Delhi.",
            },
            {
                title: "Staircase Glass Railing",
                points: ["Indoor staircase", "Duplex homes", "Office staircases"],
                note: "Provides open & spacious feel.",
            },
            {
                title: "Frameless Glass Railing",
                points: ["No heavy vertical posts", "Clean & minimal look", "Premium architectural design"],
                note: "Highly preferred in luxury homes.",
            },
            {
                title: "Terrace Glass Railing",
                points: ["Safety for terrace area", "Modern rooftop design", "Weather-resistant system"],
                note: "Toughened glass and SS fittings are weather-resistant.",
            },
        ],
        faqs: [
            { q: "Is glass railing safe?", a: "Yes. We use 10mm–15mm toughened safety glass which is highly durable." },
            { q: "Can it break easily?", a: "No, toughened glass is impact-resistant. Proper installation ensures safety." },
            { q: "Is it safe for children?", a: "Yes, when installed with proper height & secure fittings." },
            { q: "Does it require maintenance?", a: "Very low maintenance. Simple cleaning keeps it clear." },
            { q: "Which thickness is best for balcony glass railing?", a: "12mm toughened glass is commonly recommended." },
            { q: "Can I choose frameless design?", a: "Yes, frameless channel railing options available." },
            { q: "How many days does installation take?", a: "Usually 2–5 days depending on size." },
        ],
        whyChoose: [
            "20+ Years Experience in Glass Work",
            "Trusted Glass Railing Contractor in South Delhi",
            "High-Quality Toughened Glass",
            "Professional Installation Team",
            "Serving Chhatarpur, Vasant Kunj & Entire Delhi NCR",
        ],
        pricingNote:
            "Pricing depends on glass thickness (10mm / 12mm / 15mm), type of fitting (SS / Aluminium / Frameless channel), height & length, and design preference. Contact 9716043891 for exact quotation.",
    },

    {
        id: "upvc-door-window-installation",
        navLabel: "UPVC Door & Window Installation",
        slug: "upvc-door-window-installation",
        heroTitle: "Best uPVC Door & Window Installation",
        heroSubtitle: "Chhatarpur, Vasant Kunj & South Delhi",
        metaTitle: "Best uPVC Door & Window Installation in Chhatarpur, Vasant Kunj & South Delhi | SNS Glass House",
        metaDescription: "High-quality uPVC sliding windows, casement windows & doors in South Delhi. Soundproof & energy-efficient uPVC solution. Call 9716043891.",
        tagline: "uPVC Doors & Windows Dealer in South Delhi | Sliding & Casement uPVC Windows – S.N.S. Glass House",
        intro: {
            heading: "Best uPVC Door & Window Installation in Chhatarpur, Vasant Kunj & South Delhi",
            searchingFor: [
                "uPVC windows near me",
                "uPVC door dealer in Delhi",
                "Sliding uPVC windows in South Delhi",
                "uPVC window installation in Chhatarpur",
                "Balcony uPVC sliding door in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House supplies and installs high-quality uPVC sliding windows, casement windows, and uPVC doors for residential and commercial projects across South Delhi & NCR. uPVC is termite-proof, rust-free, sound-resistant, energy-efficient, and low maintenance — perfect for Delhi's heat, dust and pollution conditions.",
        },
        whatIs: {
            heading: "What Are uPVC Doors & Windows?",
            description:
                "uPVC (Unplasticized Polyvinyl Chloride) is a strong, weather-resistant material used for modern doors and windows. Perfect for Delhi's heat, dust and pollution conditions, uPVC windows help reduce outside traffic noise, maintain indoor temperature, lower electricity bills, and improve comfort.",
            points: [
                "uPVC Sliding Windows",
                "uPVC Casement Windows",
                "uPVC Sliding Doors",
                "Fixed uPVC Windows",
            ],
        },
        applications: [
            {
                title: "uPVC Sliding Windows",
                points: ["Smooth sliding", "Space saving", "Noise reduction", "Weather sealing"],
                note: "Most popular in apartments, builder floors & villas across South Delhi.",
            },
            {
                title: "uPVC Casement Windows",
                points: ["Opens inside/outside", "Better ventilation", "Strong locking system", "Airtight sealing"],
                note: "Best for bedrooms and living rooms.",
            },
            {
                title: "uPVC Sliding Doors",
                points: ["Balcony doors", "Terrace entry", "Patio doors"],
                note: "Gives modern & premium look with smooth operation.",
            },
            {
                title: "Fixed uPVC Windows",
                points: ["Staircase windows", "Office spaces", "Ventilation areas"],
                note: "Double-glazed options available for enhanced soundproofing.",
            },
        ],
        faqs: [
            { q: "Are uPVC windows strong?", a: "Yes, they are reinforced with steel inside for extra strength." },
            { q: "Do uPVC windows reduce noise?", a: "Yes, especially when combined with double-glazed glass." },
            { q: "Are they better than aluminium?", a: "uPVC offers better insulation and soundproofing." },
            { q: "Do they turn yellow?", a: "High-quality uPVC does not turn yellow easily." },
            { q: "How long do uPVC windows last?", a: "Properly installed systems last 20–25 years." },
            { q: "Which is better – sliding or casement?", a: "Sliding is space-saving; casement provides better ventilation & sealing." },
            { q: "Do you provide old window replacement?", a: "Yes, old aluminium or wooden windows can be replaced with uPVC." },
        ],
        whyChoose: [
            "20+ Years Experience in Glass & Window Solutions",
            "Trusted uPVC Window Dealer in South Delhi",
            "High-Quality Profiles & Hardware",
            "Affordable Pricing",
            "Serving Chhatarpur, Vasant Kunj & Entire Delhi NCR",
        ],
        pricingNote:
            "Pricing depends on profile quality, glass type (single / double glazed), hardware system, size & design. For accurate quotation & site visit in South Delhi, contact 9716043891.",
    },

    {
        id: "led-mirror-installation",
        navLabel: "LED Mirror Dealer & Installation",
        slug: "led-mirror-installation",
        heroTitle: "LED Mirror Dealer & Installation",
        heroSubtitle: "Backlit Bathroom Mirrors · South Delhi",
        metaTitle: "LED Mirror Dealer & Installation in South Delhi | Backlit Bathroom Mirrors – SNS Glass House",
        metaDescription: "Premium custom LED mirrors with backlight & front light in South Delhi. Round, rectangular, anti-fog LED mirrors. Trusted installer. Call 9716043891.",
        tagline: "LED Mirror Dealer & Installation in South Delhi | Backlit Bathroom Mirrors – S.N.S. Glass House",
        intro: {
            heading: "LED Mirror Dealer & Installation in South Delhi | Backlit Bathroom Mirrors",
            searchingFor: [
                "LED mirror near me",
                "Bathroom LED mirror in Delhi",
                "Backlit mirror installation in South Delhi",
                "Round LED mirror in Chhatarpur",
                "LED vanity mirror in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House is your trusted LED mirror supplier & installer. We provide premium quality custom size LED mirrors with backlight & front light options for homes, salons, hotels and commercial spaces across South Delhi & NCR.",
        },
        whatIs: {
            heading: "What Is an LED Mirror?",
            description:
                "An LED mirror is a modern mirror fitted with built-in LED lighting that provides clear & shadow-free reflection, modern luxury look, energy-efficient lighting, and long-lasting performance. Perfect for bathrooms, dressing areas, and makeup studios.",
            points: [
                "Touch Sensor On/Off",
                "Dimmer Control Option",
                "Anti-Fog System",
                "Waterproof Back Panel",
                "Energy Efficient LEDs",
                "Long Life (30,000+ hours)",
            ],
        },
        applications: [
            {
                title: "Backlit LED Mirror",
                points: ["Light glows from behind", "Creates floating wall effect", "Premium hotel-style look"],
                note: "Most popular in luxury bathrooms in South Delhi.",
            },
            {
                title: "Front Light LED Mirror",
                points: ["LED strip on front edges", "Bright and focused lighting", "Ideal for makeup & grooming"],
                note: "Provides shadow-free, even lighting.",
            },
            {
                title: "Round LED Mirror",
                points: ["Modern circular design", "Perfect for small bathrooms", "Stylish & elegant"],
                note: "A contemporary design choice for modern interiors.",
            },
            {
                title: "Rectangular / Custom Shape LED Mirror",
                points: ["Full-size vanity mirrors", "Wall-to-wall LED mirrors", "Custom size as per requirement"],
                note: "Fully customized as per wall space and design requirement.",
            },
        ],
        faqs: [
            { q: "Is LED mirror safe for bathroom?", a: "Yes, waterproof & moisture-resistant design is used." },
            { q: "Does it consume high electricity?", a: "No, LED lights are energy-efficient." },
            { q: "What if LED stops working?", a: "LED driver can be replaced if required." },
            { q: "Can I customize size?", a: "Yes, custom sizes available as per wall space." },
            { q: "Do you provide custom LED mirror size?", a: "Yes, fully customized options available." },
            { q: "Is anti-fog feature available?", a: "Yes, optional anti-fog system available." },
            { q: "Do you provide warranty?", a: "Yes, warranty on LED components (terms apply)." },
        ],
        whyChoose: [
            "20+ Years Experience in Glass & Mirror Work",
            "Trusted LED Mirror Dealer in South Delhi",
            "Custom Size Available",
            "Premium Quality Materials",
            "Serving Chhatarpur, Vasant Kunj & Entire Delhi NCR",
        ],
        pricingNote:
            "Price depends on size, shape, lighting type, and features (anti-fog, dimmer, sensor). For accurate quotation & site visit in South Delhi, call 9716043891.",
    },

    {
        id: "ss-partition-contractor",
        navLabel: "SS Partition Contractor",
        slug: "ss-partition-contractor",
        heroTitle: "Best SS Partition Contractor",
        heroSubtitle: "Chhatarpur, Vasant Kunj & South Delhi",
        metaTitle: "Best SS Partition Contractor in Chhatarpur, Vasant Kunj & South Delhi | SNS Glass House",
        metaDescription: "Premium stainless steel glass partitions for offices, showrooms & clinics in South Delhi. SS 304 grade. Expert installation. Call 9716043891.",
        tagline: "SS Partition Work in South Delhi | Stainless Steel Glass Partition – S.N.S. Glass House",
        intro: {
            heading: "Best SS Partition Contractor in Chhatarpur, Vasant Kunj & South Delhi",
            searchingFor: [
                "SS partition near me",
                "Stainless steel glass partition in Delhi",
                "SS cabin partition in South Delhi",
                "SS & glass partition in Chhatarpur",
                "Office SS partition in Vasant Kunj",
            ],
            description:
                "S.N.S. Glass House provides premium SS frame partitions combined with toughened glass panels for offices, showrooms, clinics, banks and commercial spaces across South Delhi & NCR.",
        },
        whatIs: {
            heading: "What Is SS Partition?",
            description:
                "SS Partition (Stainless Steel Partition) is a strong framing system made from stainless steel profiles combined with glass panels or solid sheets. It offers strong structural support, premium metallic finish, long-lasting durability, and modern professional appearance — ideal for commercial environments.",
            points: [
                "SS Frame + Toughened Glass",
                "SS Frame + Laminated Glass",
                "SS Frame + Solid Panels",
                "Brushed Finish SS",
                "Mirror Finish SS",
            ],
        },
        applications: [
            {
                title: "Office Cabin Partition",
                points: ["Manager cabins", "Director rooms", "Conference rooms", "Corporate offices"],
                note: "Provides strong structure with modern look.",
            },
            {
                title: "Commercial & Showroom Partition",
                points: ["Jewelry shops", "Mobile showrooms", "Retail stores", "Bank counters"],
                note: "Enhances durability and premium appeal.",
            },
            {
                title: "Clinic & Hospital Partition",
                points: ["Reception areas", "Consultation cabins", "Pharmacy counters"],
                note: "SS is hygienic and easy to maintain.",
            },
            {
                title: "Industrial & Factory Use",
                points: ["Production office partitions", "Warehouse office cabins", "Security cabin partitions"],
                note: "Strong and long-lasting structure for heavy traffic areas.",
            },
        ],
        faqs: [
            { q: "Does stainless steel rust?", a: "High-quality SS (304 grade) is rust-resistant." },
            { q: "Is SS stronger than aluminium?", a: "Yes, stainless steel is stronger and more durable." },
            { q: "Can SS partition be combined with toughened glass?", a: "Yes, very common and highly recommended combination." },
            { q: "Does it require maintenance?", a: "Minimal maintenance. Regular cleaning keeps it shiny." },
            { q: "Which SS grade is better?", a: "304 grade stainless steel is recommended for durability." },
            { q: "Can SS partition be customized?", a: "Yes, fully customized as per office design." },
            { q: "Do you provide repair services?", a: "Yes, repair & modification services available." },
        ],
        whyChoose: [
            "20+ Years Experience in Glass & Metal Work",
            "Trusted SS Partition Contractor in South Delhi",
            "High-Quality Stainless Steel",
            "Professional Installation Team",
            "Serving Chhatarpur, Vasant Kunj & Entire Delhi NCR",
        ],
        pricingNote:
            "Pricing depends on SS grade (202 / 304), glass thickness, frame design and project size. For accurate quotation & site visit in Vasant Kunj or South Delhi, call 9716043891.",
    },
];
